import { useEffect, useState } from "react";
import api from "../axiosInstance";

function useMessage(filters) {
  const {
    universityId,
    semesterId,
    courseId,
    regulationId,
    conversationId,
    rowsPerPage,
    page,
  } = filters || {};

  const [universityList, setUniversityList] = useState([]);
  const [coursesList, setCoursesList] = useState([]);
  const [semestersList, setSemestersList] = useState([]);
  const [regulationsList, setRegulationsList] = useState([]);
  const [BooksList, setBooksList] = useState([]);
  const [messages, setMessages] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch all universities
  useEffect(() => {
    setLoading(true);
    api
      .get("/getAllUniversities")
      .then((res) => setUniversityList(res.data.data))
      .catch(() => setError("Failed to load universities."))
      .finally(() => setLoading(false));
  }, []);

  // Fetch courses by universityId
  useEffect(() => {
    if (!universityId || universityId === "" || universityId === null) {
      // Do not call API until regulationId is valid
      return;
    }
    setLoading(true);
    api
      .get(`/getCourses/${universityId}`)
      .then((res) => setCoursesList(res.data.data))
      .catch(() => console.log("Failed to load courses."))
      .finally(() => setLoading(false));
  }, [universityId]);

  // Fetch all semesters
  useEffect(() => {
    setLoading(true);
    api
      .get(`/getSemesters`)
      .then((res) => setSemestersList(res.data.data))
      .catch(() => setError("Failed to load semesters."))
      .finally(() => setLoading(false));
  }, []);

  // Fetch all regulations
  useEffect(() => {
    setLoading(true);
    api
      .get(`/api/regulation-years`)
      .then((res) => setRegulationsList(res.data.data))
      .catch(() => setError("Failed to load regulations."))
      .finally(() => setLoading(false));
  }, []);

  // Fetch books by regulationId
  //   useEffect(() => {
  //     if (!semesterId || semesterId === "" || semesterId === null) {
  //       // Do not call API until regulationId is valid
  //       return;
  //     }
  //     setLoading(true);
  //     api
  //       .get(`/chatroom/semesters/${semesterId}`)
  //       .then((res) => setBooksList(res.data.data?.content || []))
  //       .catch(() => setError("Failed to load books."))
  //       .finally(() => setLoading(false));
  //   }, [semesterId]);

  //   console.log(BooksList);

  //  Fetch messages (only when filters are ready)
  useEffect(() => {
    if (!conversationId) {
      setMessages([]);
      setTotalElements(0);
      return;
    }

    setLoading(true);
    api
      .get(`/getAllMessages`, {
        params: { page, size: rowsPerPage, bookId: conversationId },
      })
      .then((res) => {
        const data = res.data?.data;
        setMessages(data?.content || []);
        // setTotalElements(
        //   typeof data?.totalElements === "number" ? data.totalElements : 0
        // );
      })
      .catch(() => setError("Failed to load messages."))
      .finally(() => setLoading(false));
  }, [conversationId, page, rowsPerPage]);
  console.log(universityId);

  //  Fetch messages (only when filters are ready)
  useEffect(() => {
    if (
      !filters ||
      (!universityId && !courseId && !regulationId && !semesterId)
    ) {
      setBooksList([]);
      setTotalElements(0);
      return;
    }

    setLoading(true);
    api
      .get(`/getAllMessages`, {
        params: {
          page,
          size: rowsPerPage,
          universityId: universityId,
          courseId: courseId,
          regulationId: regulationId,
          semesterId: semesterId,
        },
      })
      .then((res) => {
        const data = res.data?.data;
        setBooksList(data?.content || []);
        setTotalElements(
          typeof data?.totalElements === "number" ? data.totalElements : 0,
        );
        console.log(data);
      })
      .catch(() => setError("Failed to load messages."))
      .finally(() => setLoading(false));
  }, [universityId, courseId, regulationId, semesterId, page, rowsPerPage]);
  console.log(BooksList);

  // Return everything
  return {
    universityList,
    coursesList,
    semestersList,
    regulationsList,
    BooksList,
    messages,
    totalElements,
    loading,
    error,
    setError,
    setLoading,
  };
}

export default useMessage;
